import PropTypes from "prop-types";
import React, { useState } from "react";
import { Field } from "redux-form";
import { Button } from "primereact/button";

export const RemarksField = ({ input }) => {
  return (
    <>
      <label className="input-label">Remarks :</label>
      <textarea {...input} className="input-style p-inputtext w-full" />
    </>
  );
};

const RemarkDetails = (props) => {
  const { handleSubmit, setShowRemarks} = props;
  const [remarksValue, setRemarksValue] = useState("");

  const handleCancel = () => {
    setShowRemarks(false);
    setRemarksValue("");
  };

  const submit = () => {
      handleSubmit();
      console.log("remarksValue",remarksValue)
      setRemarksValue("");
  };

  return (
    // <form onSubmit={handleSubmit(submit)}>
      <div className="m-3 master-form">
        <div className="col-12 md:col-6 flex-column flex">
          <Field
            name="remarks"
            component={RemarksField}
            // input={{
            //   value: remarksValue,
            //   onChange: (e) => setRemarksValue(e.target.value),
            // }}
          />
        </div>
        <div className="flex gap-3 mastersFormBtnGroup justify-content-center m-2">
          <Button
            className="btn"
            data-testid="cancel"
            label="Cancel"
            onClick={handleCancel}
          />
          <Button
            data-testid="submit"
            className="btn btn-primary-filled"
            label="Submit"
            // type="submit"
            onClick={submit}
          />
        </div>
      </div>
    // </form>
  );
};

RemarkDetails.propTypes = {
  remarks: PropTypes.string.isRequired,
};

export default RemarkDetails;
